import { RootState } from '@/app/redux/store';
import { ShareLink } from '@/common/types/shareLink';
import { Student } from '@/common/types/student';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ShareLinkState {
  shareLink: ShareLink | null;
  student: Student | null;
}

const initialState: ShareLinkState = {
  shareLink: null,
  student: null,
};

const globalStateSlice = createSlice({
  name: 'globalState',
  initialState,
  reducers: {
    setShareLinkState: (_state, action: PayloadAction<ShareLinkState>) => {
      return action.payload;
    },
  },
});

export default globalStateSlice.reducer;
export const { setShareLinkState } = globalStateSlice.actions;

export const selectShareLink = (state: RootState) => state.shareLink;
